import { render } from "./Competitor.vue?vue&type=template&id=24947d5c"
import script from "./Competitor.vue?vue&type=script&lang=js"
export * from "./Competitor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__